Ext.ns('mx.comp');
// Custom accordion layout that does not allow the accordion to be fully closed.
// I.e., at least one panel must be open, and that panel cannot be explicitly closed.

mx.comp.AccordionLayout = Ext.extend(Ext.layout.ContainerLayout, {
    /**
     * @cfg {Boolean} fill
     * True to adjust the active item's height to fill the available space in the container, false to use the
     * item's current height, or auto height if not explicitly set (defaults to true).
     */
    fill: true,
    /**
     * @cfg {Boolean} autoWidth
     * True to set each contained item's width to 'auto', false to use the item's current width (defaults to true).
     * Note that some components, in particular the {@link Ext.grid.GridPanel grid}, will not function properly within
     * layouts if they have auto width, so in such cases this config should be set to false.
     */
    autoWidth: true,
    autoHeight: true,

    /**
     * @cfg {Boolean} titleCollapse
     * True to allow expand/collapse of each contained panel by clicking anywhere on the title bar, false to allow
     * expand/collapse only when the toggle tool button is clicked (defaults to true).  When set to false,
     * {@link #hideCollapseTool} should be false also.
     */
    titleCollapse: true,
    /**
     * @cfg {Boolean} hideCollapseTool
     * True to hide the contained panels' collapse/expand toggle buttons, false to display them (defaults to false).
     * When set to true, {@link #titleCollapse} should be true also.
     */
    hideCollapseTool: false,
    /**
     * @cfg {Boolean} collapseFirst
     * True to make sure the collapse/expand toggle button always renders first (to the left of) any other tools
     * in the contained panels' title bars, false to render it last (defaults to false).
     */
    collapseFirst: false,
    /**
     * @cfg {Boolean} animate
     * True to slide the contained panels open and closed during expand/collapse using animation, false to open and
     * close directly with no animation (defaults to false).  Note: to defer to the specific config setting of each
     * contained panel for this property, set this to undefined at the layout level.
     */
    animate: false,
    /**
     * @cfg {Boolean} sequence
     * <b>Experimental</b>. If animate is set to true, this will result in each animation running in sequence.
     */
    sequence: false,
    /**
     * @cfg {Boolean} activeOnTop
     * True to swap the position of each panel as it is expanded so that it becomes the first item in the container,
     * false to keep the panels in the rendered order. <b>This is NOT compatible with "animate:true"</b> (defaults to false).
     */
    activeOnTop: false,
    // private
    monitorResize: true,

    renderItem: function(c) {
        if (c.nonVisual) {
            //non visual element
            return;
        }
        if (this.animate === false) {
            c.animCollapse = false;
        }
        c.collapsible = true;
        if (this.autoHeight) {
            c.autoHeight = true;
        }
        if (this.autoWidth) {
            c.autoWidth = true;
        }
        if (this.titleCollapse) {
            c.titleCollapse = true;
        }
        if (this.hideCollapseTool) {
            c.hideCollapseTool = true;
        }
        c.collapsed = true;
        mx.comp.AccordionLayout.superclass.renderItem.apply(this, arguments);
        if (c.header) {
            c.header.addClass('x-accordion-hd');
        }
        c.on('beforeexpand', this.beforeExpand, this);
    },

    renderAll: function(ct, target) {
        mx.comp.AccordionLayout.superclass.renderAll.apply(this, arguments);
        ct.body.setStyle('overflow-y', 'auto');
        if (ct.items.items.length > 0) {
            ct.fireEvent('afterrender');
        }
    },

    beforeExpand: function(p, anim) {
        this.activeItem = p;

        this.layout();
    },
});
Ext.Container.LAYOUTS['mx-accordion'] = mx.comp.AccordionLayout;
